import { BudgetBucketAttributes } from '@callmart/types';
import api from './index';

const BASE = '/budget-buckets';

export interface BudgetBucket extends BudgetBucketAttributes {}

export const getBudgetBuckets = async (): Promise<BudgetBucket[]> => {
    return api.get(BASE).then((res) => res.data);
};

export const createBudgetBucket = async (data: { name: string }): Promise<BudgetBucket> => {
    return api.post(BASE, data).then((res) => res.data);
};

export const updateBudgetBucket = async ({ id, ...data }: { id: number; name: string }): Promise<BudgetBucket> => {
    return api.patch(`${BASE}/${id}`, data).then((res) => res.data);
};

export const deleteBudgetBucket = async (id: number) => {
    return api.delete(`${BASE}/${id}`).then((res) => res.data);
};
